import 'bootstrap/dist/css/bootstrap.css';
import AnswersList from './AnswersList';
import LocPageFooter from './PageFooter';

function LocAnswersMethodist() {
  const parkingType = (
    <ul style={{ marginBottom: 1 }}>
      <li>Daytime (24 hour / 7 day access)</li>
      <li>
        Nights & weekends (entry M–F after 1:30 p.m. + weekends + holidays, exit
        anytime){' '}
      </li>
    </ul>
  );

  const waitingList =
    'For day commuter parking, yes. No waiting list for night shift commuters';

  const campusName = 'Brooklyn Methodist Hospital (BMH) campus';
  const campusContact = 'parkingnyp-bmh@nyp.org';
  const carStorage =
    `No. ${campusName} Campus parking is for commuters only.` +
    'Vehicles must be removed promptly following end of shift.';
  const telNum = '718-369-8185';
  const eligible = '';

  return (
    <div style={{ marginBottom: 20 }}>
      <LocPageFooter
        title={`For answers related to NYP ${campusName} parking locations, 
        Click on the questions below.`}
      />

      <AnswersList
        parkType={parkingType}
        waitList={waitingList}
        campus={campusName}
        contact={campusContact}
        storage={carStorage}
        tel={telNum}
        eligibleGrp={eligible}
      />
    </div>
  );
}

export default LocAnswersMethodist;
